import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import {
  DOSAGE_UNIT_LABELS,
  PACKAGE_MEASUREMENT_UNIT_LABELS,
} from '@/shared/pharmacy/enum';
import { enumToOptions } from '@/utils/utils';

export const createModalConfig = (drugsTypes: any) =>
  [
    {
      label: 'Наименование препарата',
      key: 'drugId',
      type: 'select',
      payload: {
        options: drugsTypes,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
      validation: [Validators.required()],
    },
    {
      label: 'Номер партии',
      key: 'batchNumber',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Дата поступления партии',
      key: 'receiptDate',
      type: 'date',
      validation: [Validators.required()],
    },
    {
      label: 'Дата конца срока годности партии',
      key: 'expirationDate',
      type: 'date',
      validation: [Validators.required()],
    },
    {
      label: 'Срок годности после вскрытия препарата (дней)',
      key: 'expirationPeriod',
      type: 'number',
    },
    {
      label: 'Количество ед. тары',
      key: 'packagesAmount',
      type: 'number',
      validation: [Validators.required()],
    },
    {
      label: 'Единица тары',
      key: 'packageUnit',
      type: 'select',
      payload: {
        options: enumToOptions(PACKAGE_MEASUREMENT_UNIT_LABELS),
      },
    },
    {
      label: 'Единица содержимого',
      key: 'dosageUnit',
      type: 'select',
      payload: {
        options: enumToOptions(DOSAGE_UNIT_LABELS),
      },
    },
    {
      label: 'Объем/доза препарата на единицу тары',
      key: 'packageVolume',
      type: 'number',
      validation: [Validators.required()],
    },

    {
      label: 'Требуемый минимальный остаток ед. тары',
      key: 'minAmount',
      type: 'text',
      validation: [Validators.required()],
    },
  ] as IFormItem[];

export const createBatchModalConfig = [
  {
    label: 'Номер партии',
    key: 'batchNumber',
    type: 'text',
    validation: [Validators.required()],
  },
  {
    label: 'Дата поступления партии',
    key: 'receiptDate',
    type: 'date',
    validation: [Validators.required()],
  },
  {
    label: 'Дата конца срока годности партии',
    key: 'expirationDate',
    type: 'date',
    validation: [Validators.required()],
  },
  {
    label: 'Срок годности после вскрытия препарата (дней)',
    key: 'expirationPeriod',
    type: 'number',
  },
  {
    label: 'Количество ед. тары',
    key: 'packagesAmount',
    type: 'number',
    validation: [Validators.required()],
  },
  {
    label: 'Единица тары',
    key: 'packageUnit',
    type: 'select',
    payload: {
      options: enumToOptions(PACKAGE_MEASUREMENT_UNIT_LABELS),
    },
  },
  {
    label: 'Единица содержимого',
    key: 'dosageUnit',
    type: 'select',
    payload: {
      options: enumToOptions(DOSAGE_UNIT_LABELS),
    },
  },
  {
    label: 'Объем/доза препарата на единицу тары',
    key: 'packageVolume',
    type: 'number',
    validation: [Validators.required()],
  },
] as IFormItem[];

export const deleteBatchModalConfig = [
  {
    label: 'Основание',
    placeholder: 'Введите основание',
    key: 'basis',
    type: 'text',
  },
] as IFormItem[];
